const trackEvent = (name, params = {}) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, { ...params });
};

export const trackPageView = (path) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const GA = {
  salesRepSignupStarted: () =>
    trackEvent('salesrep_signup_started'),

  salesRepSignupCompleted: (plan = 'free') =>
    trackEvent('salesrep_signup_completed', { plan }),

  clientSignupCompleted: () =>
    trackEvent('client_signup_completed'),

  contractorSignupCompleted: () =>
    trackEvent('contractor_signup_completed'),

  planSelected: (planName, planPrice) =>
    trackEvent('plan_selected', { plan_name: planName, value: planPrice, currency: 'CAD' }),

  promoCodeApplied: (code) =>
    trackEvent('promo_code_applied', { promo_code: code }),

  leadClaimed: (leadId, companyName) =>
    trackEvent('lead_claimed', { lead_id: leadId, company: companyName }),

  callInitiated: (callType = 'outbound') =>
    trackEvent('call_initiated', { call_type: callType }),

  dealClosed: (dealValue) =>
    trackEvent('deal_closed', { value: dealValue, currency: 'CAD' }),

  payoutRequested: (amount) =>
    trackEvent('payout_requested', { value: amount, currency: 'CAD' }),

  creditTopupPurchased: (credits, amount) =>
    trackEvent('credit_topup_purchased', { credits, value: amount, currency: 'CAD' }),
};

export default GA;
